"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudienceList = void 0;
var _List = require("../../../../../../../Data/List");
var _hooks = require("../../../../../../../hooks");
var _AudiencePicker = require("../../../../../AudiencePicker.helpers");
var _AudiencePickerProvider = require("../../../../../provider/AudiencePickerProvider.helpers");
var _AudienceListItem = require("./partials/AudienceListItem");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AudienceList = function AudienceList(props) {
  var audienceIds = props.audienceIds,
    _props$selectedAudien = props.selectedAudienceIds,
    selectedAudienceIds = _props$selectedAudien === void 0 ? [] : _props$selectedAudien,
    readOnlyMapper = props.readOnlyMapper,
    mapper = props.mapper,
    audienceType = props.audienceType,
    selectedClassesIds = props.selectedClassesIds,
    selectedGroupsIds = props.selectedGroupsIds,
    selectedStudentsIds = props.selectedStudentsIds,
    isReadOnly = props.isReadOnly,
    onDisableItemClick = props.onDisableItemClick,
    onDeleteItem = props.onDeleteItem,
    onSelectedChanged = props.onSelectedChanged,
    setCantRemoveMessage = props.setCantRemoveMessage,
    searchedStudentsData = props.searchedStudentsData,
    originalSelectedGroupsIds = props.originalSelectedGroupsIds,
    originalSelectedClassesIds = props.originalSelectedClassesIds,
    originalSelectedStudentsIds = props.originalSelectedStudentsIds;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var handleDisabledItemClick = function handleDisabledItemClick() {
    if (onDisableItemClick) {
      setCantRemoveMessage(onDisableItemClick());
    }
  };
  var unSelectedIds = audienceIds === null || audienceIds === void 0 ? void 0 : audienceIds.filter(function (id) {
    return selectedAudienceIds && selectedAudienceIds.indexOf(id) < 0;
  });
  var ids = isMobileView ? audienceIds : unSelectedIds;
  if (!ids) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List, {
    id: audienceType,
    children: ids.map(function (id, i) {
      var _id;
      var isItemReadonly = isReadOnly || readOnlyMapper[id];
      var isSelected = Boolean(selectedAudienceIds && selectedAudienceIds.indexOf(id) >= 0);
      var selected = audienceType === 'students' ? {
        selectedClassesIds: selectedClassesIds,
        selectedGroupsIds: selectedGroupsIds,
        selectedStudentsIds: (0, _AudiencePicker.getSelectedIds)(selectedAudienceIds, isSelected, id)
      } : audienceType === 'groups' ? {
        selectedClassesIds: selectedClassesIds,
        selectedStudentsIds: selectedStudentsIds,
        selectedGroupsIds: (0, _AudiencePicker.getSelectedIds)(selectedAudienceIds, isSelected, id)
      } : {
        selectedStudentsIds: selectedStudentsIds,
        selectedGroupsIds: selectedGroupsIds,
        selectedClassesIds: (0, _AudiencePicker.getSelectedIds)(selectedAudienceIds, isSelected, id)
      };
      var handleChange = function handleChange() {
        var originalAudience = audienceType === 'students' ? originalSelectedStudentsIds : audienceType === 'groups' ? originalSelectedGroupsIds : originalSelectedClassesIds;
        var currentAudience = audienceType === 'students' ? selected.selectedStudentsIds : audienceType === 'groups' ? selected.selectedGroupsIds : selected.selectedClassesIds;
        if (onDeleteItem && !(0, _AudiencePicker.checkSubset)(currentAudience !== null && currentAudience !== void 0 ? currentAudience : [], originalAudience !== null && originalAudience !== void 0 ? originalAudience : [])) {
          setCantRemoveMessage(onDeleteItem());
        }
        onSelectedChanged(selected);
      };
      var fullNameHtml = searchedStudentsData && searchedStudentsData.filter(function (student) {
        return student.id === id;
      })[0].fullNameHtml;
      var fullName = fullNameHtml || mapper && (0, _AudiencePickerProvider.getStudentFullName)((_id = mapper[id]) === null || _id === void 0 ? void 0 : _id.student);
      return /*#__PURE__*/(0, _react.createElement)(_AudienceListItem.AudienceListItem, _objectSpread(_objectSpread({}, props), {}, {
        key: id,
        id: id,
        isSelected: isSelected,
        isItemReadonly: isItemReadonly,
        audienceType: audienceType,
        fullName: fullName,
        onChange: handleChange,
        onDisabledItemClick: handleDisabledItemClick
      }));
    })
  });
};
exports.AudienceList = AudienceList;